module.exports = __webpack_public_path__ + "static/media/white-camera.6b483f80.svg";